import { accountParentOf } from '@hue/contracts';

/// O próximo número livre debaixo de um grupo ou de uma conta, para a pessoa só confirmar.
export function nextCodeUnder(parent: string, accounts: readonly { code: string }[]): string {
  const used = accounts
    .filter((account) => accountParentOf(account.code) === parent)
    .map((account) => Number(account.code.split('.').at(-1)));
  return `${parent}.${used.length ? Math.max(...used) + 1 : 1}`;
}
